import type { NewsItem } from "@/mocks/chiGuaData";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-1 hover:border-primary-300">
      <a href="#browse" className="relative block overflow-hidden">
        <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} - 吃瓜网上浏览推荐`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        {item.hot && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-foreground-950">
            <i className="ri-fire-fill" aria-hidden="true"></i> 热门
          </span>
        )}
      </a>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2">
          <span className="whitespace-nowrap rounded bg-secondary-500/15 px-2 py-0.5 text-xs font-medium text-secondary-800">
            {item.category}
          </span>
          <span className="text-xs text-foreground-500">{item.time}</span>
        </div>
        <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950">
          <a href="#browse" className="transition-colors hover:text-primary-600">
            {item.title}
          </a>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {item.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-eye-line" aria-hidden="true"></i> {item.reads} 阅读
          </span>
          <a
            href="#browse"
            className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            去看看 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </article>
  );
}